import { useMemo } from 'react';

type Filters = {
  [key: string]: any;
};

const isArrayEmpty = (value: any): boolean => Array.isArray(value) && value.length === 0;
const isObjectEmpty = (value: any): boolean =>
  typeof value === 'object' && value !== null && Object.keys(value).length === 0;
const isValueEmpty = (value: any): boolean => value === undefined || value === '' || value === null;

export const isFieldDirty = (fieldName: string, filters: Filters): boolean => {
  const value = filters[fieldName];
  if (isArrayEmpty(value) || isObjectEmpty(value) || isValueEmpty(value)) {
    return false;
  }
  return true;
};

const useIsDirty = (fieldsNames: string[], filters: Filters): boolean =>
  useMemo(
    () => fieldsNames.some((fieldName) => isFieldDirty(fieldName, filters)),
    [fieldsNames, filters]
  );

export default useIsDirty;
